<template>
  <div class="wallet-page">
    <el-card class="wallet-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>钱包余额</span>
      </div>
      <div class="balance-box">
        <div class="amount">￥{{ yuan(balance) }}</div>
        <div class="meta">当前账户余额（元）</div>
      </div>
    </el-card>

    <el-card class="wallet-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>支付密码</span>
      </div>
      <div v-if="payPwdSet" class="pwd-status">
        <i class="el-icon-lock"></i>
        <span>已设置支付密码</span>
        <div class="actions">
          <el-button type="text" @click="openModifyDialog">修改</el-button>
        </div>
      </div>
      <el-form v-else ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="设置支付密码" prop="password">
          <el-input v-model="form.password" show-password placeholder="请输入支付密码" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <router-link class="bill-link" to="/home/wallet/bill">
      <el-card class="wallet-card" shadow="hover">
        <div class="bill-entry">
          <i class="el-icon-document"></i>
          <span>账单</span>
        </div>
      </el-card>
    </router-link>
    <el-dialog :visible.sync="modifyVisible" title="修改支付密码" width="420px" @close="onModifyClose">
      <el-form :model="modifyForm" :rules="modifyRules" ref="modifyFormRef" label-width="100px">
        <el-form-item label="历史密码" prop="oldPassword">
          <el-input v-model="modifyForm.oldPassword" show-password placeholder="请输入历史支付密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="modifyForm.password" show-password placeholder="请输入新的支付密码" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onModifyCancel">取消</el-button>
        <el-button type="primary" :loading="modifyLoading" @click="onModifySubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WalletSetting',
  data() {
    return {
      balance: 0,
      payPwdSet: false,
      loading: false,
      form: { password: '' },
      rules: { password: [{ required: true, message: '请输入支付密码', trigger: 'blur' }] },
      modifyVisible: false,
      modifyLoading: false,
      modifyForm: { oldPassword: '', password: '' },
      modifyRules: {
        oldPassword: [{ required: true, message: '请输入历史支付密码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入新的支付密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    yuan(cents) { return (cents / 100).toFixed(2); },
    async init() {
      const vo = await this.$http({ url: '/wallet/balance', method: 'GET' });
      this.balance = vo.balance || 0;
      this.payPwdSet = !!vo.payPwdSet;
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          await this.$http({ url: '/wallet/paypwd/set', method: 'POST', data: { password: this.form.password } });
          this.$message.success('支付密码设置成功');
          this.payPwdSet = true;
        } catch (e) {
          let _ = e;
        } finally {
          this.loading = false;
        }
      })
    },
    openModifyDialog() {
      this.modifyForm.oldPassword = '';
      this.modifyForm.password = '';
      this.modifyVisible = true;
    },
    onModifyClose() {
      this.modifyForm.oldPassword = '';
      this.modifyForm.password = '';
      this.modifyLoading = false;
    },
    onModifyCancel() {
      this.modifyVisible = false;
      this.scrollToBalance();
    },
    onModifySubmit() {
      this.$refs.modifyFormRef.validate(async valid => {
        if (!valid) return;
        this.modifyLoading = true;
        try {
          await this.$http({ url: '/wallet/paypwd/set', method: 'POST', data: { oldPassword: this.modifyForm.oldPassword, password: this.modifyForm.password } });
          this.$message.success('支付密码修改成功');
          this.modifyVisible = false;
          this.scrollToBalance();
        } catch (e) {
          let _ = e;
        } finally {
          this.modifyLoading = false;
        }
      })
    },
    scrollToBalance() {
      const el = this.$el && this.$el.querySelector('.balance-box');
      el && el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
</script>

<style scoped>
.wallet-page { padding: 20px; }
.wallet-card { margin-bottom: 16px; }
.balance-box { text-align: center; padding: 20px 0; }
.amount { font-size: 32px; font-weight: 700; color: #303133; }
.meta { color: #909399; margin-top: 6px; }
.pwd-status { display:flex; align-items:center; gap:8px; color:#67C23A; font-weight:600; }
.pwd-status .actions { margin-left: auto; }
.dialog-footer { text-align: right; }
.bill-entry { display:flex; align-items:center; gap:8px; font-weight:600; color:#303133; cursor:pointer; }
.bill-link { display:block; }
</style>
